import { render, staticRenderFns } from "./TraxAccountUserCrud.vue?vue&type=template&id=8e19cca0"
import script from "./TraxAccountUserCrud.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports